import NavLogo from './nav-logo'

export default NavLogo
